/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import { __assign } from "tslib";
import { CloudErrorMapper, BaseResourceMapper } from "@azure/ms-rest-azure-js";
export var CloudError = CloudErrorMapper;
export var BaseResource = BaseResourceMapper;
export var TrackedResourceUpdate = {
  serializedName: "TrackedResourceUpdate",
  type: {
    name: "Composite",
    className: "TrackedResourceUpdate",
    modelProperties: {
      tags: {
        serializedName: "tags",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
export var AutoShutdownProfile = {
  serializedName: "AutoShutdownProfile",
  type: {
    name: "Composite",
    className: "AutoShutdownProfile",
    modelProperties: {
      shutdownOnDisconnect: {
        serializedName: "shutdownOnDisconnect",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      shutdownWhenNotConnected: {
        serializedName: "shutdownWhenNotConnected",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      shutdownOnIdle: {
        serializedName: "shutdownOnIdle",
        type: {
          name: "Enum",
          allowedValues: ["None", "UserAbsence", "LowUsage"]
        }
      },
      disconnectDelay: {
        serializedName: "disconnectDelay",
        type: {
          name: "TimeSpan"
        }
      },
      noConnectDelay: {
        serializedName: "noConnectDelay",
        type: {
          name: "TimeSpan"
        }
      },
      idleDelay: {
        serializedName: "idleDelay",
        type: {
          name: "TimeSpan"
        }
      }
    }
  }
};
export var ConnectionProfile = {
  serializedName: "ConnectionProfile",
  type: {
    name: "Composite",
    className: "ConnectionProfile",
    modelProperties: {
      webSshAccess: {
        serializedName: "webSshAccess",
        type: {
          name: "Enum",
          allowedValues: ["Public", "Private", "None"]
        }
      },
      webRdpAccess: {
        serializedName: "webRdpAccess",
        type: {
          name: "Enum",
          allowedValues: ["Public", "Private", "None"]
        }
      },
      clientSshAccess: {
        serializedName: "clientSshAccess",
        type: {
          name: "Enum",
          allowedValues: ["Public", "Private", "None"]
        }
      },
      clientRdpAccess: {
        serializedName: "clientRdpAccess",
        type: {
          name: "Enum",
          allowedValues: ["Public", "Private", "None"]
        }
      }
    }
  }
};
export var ResourceOperationError = {
  serializedName: "ResourceOperationError",
  type: {
    name: "Composite",
    className: "ResourceOperationError",
    modelProperties: {
      timestamp: {
        serializedName: "timestamp",
        type: {
          name: "DateTime"
        }
      },
      code: {
        serializedName: "code",
        type: {
          name: "String"
        }
      },
      message: {
        serializedName: "message",
        type: {
          name: "String"
        }
      },
      action: {
        serializedName: "action",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var SystemData = {
  serializedName: "systemData",
  type: {
    name: "Composite",
    className: "SystemData",
    modelProperties: {
      createdBy: {
        serializedName: "createdBy",
        type: {
          name: "String"
        }
      },
      createdByType: {
        serializedName: "createdByType",
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        type: {
          name: "DateTime"
        }
      },
      lastModifiedBy: {
        serializedName: "lastModifiedBy",
        type: {
          name: "String"
        }
      },
      lastModifiedByType: {
        serializedName: "lastModifiedByType",
        type: {
          name: "String"
        }
      },
      lastModifiedAt: {
        serializedName: "lastModifiedAt",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
export var Identity = {
  serializedName: "Identity",
  type: {
    name: "Composite",
    className: "Identity",
    modelProperties: {
      principalId: {
        readOnly: true,
        serializedName: "principalId",
        type: {
          name: "String"
        }
      },
      tenantId: {
        readOnly: true,
        serializedName: "tenantId",
        type: {
          name: "String"
        }
      },
      type: {
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: ["SystemAssigned", "UserAssigned", "SystemAssigned,UserAssigned", "None"]
        }
      }
    }
  }
};
export var Resource = {
  serializedName: "Resource",
  type: {
    name: "Composite",
    className: "Resource",
    modelProperties: {
      id: {
        readOnly: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      name: {
        readOnly: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      type: {
        readOnly: true,
        serializedName: "type",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var TrackedResource = {
  serializedName: "TrackedResource",
  type: {
    name: "Composite",
    className: "TrackedResource",
    modelProperties: __assign(__assign({}, Resource.type.modelProperties), {
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      },
      location: {
        required: true,
        serializedName: "location",
        type: {
          name: "String"
        }
      }
    })
  }
};
export var LabPlan = {
  serializedName: "LabPlan",
  type: {
    name: "Composite",
    className: "LabPlan",
    modelProperties: __assign(__assign({}, TrackedResource.type.modelProperties), {
      systemData: {
        readOnly: true,
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData"
        }
      },
      defaultConnectionProfile: {
        serializedName: "properties.defaultConnectionProfile",
        type: {
          name: "Composite",
          className: "ConnectionProfile"
        }
      },
      defaultAutoShutdownProfile: {
        serializedName: "properties.defaultAutoShutdownProfile",
        type: {
          name: "Composite",
          className: "AutoShutdownProfile"
        }
      },
      defaultNetworkProfile: {
        serializedName: "properties.defaultNetworkProfile",
        type: {
          name: "Composite",
          className: "LabPlanNetworkProfile"
        }
      },
      allowedRegions: {
        serializedName: "properties.allowedRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      sharedGalleryId: {
        serializedName: "properties.sharedGalleryId",
        type: {
          name: "String"
        }
      },
      supportInfo: {
        serializedName: "properties.supportInfo",
        type: {
          name: "Composite",
          className: "SupportInfo"
        }
      },
      linkedLmsInstance: {
        serializedName: "properties.linkedLmsInstance",
        type: {
          name: "String"
        }
      },
      provisioningState: {
        readOnly: true,
        serializedName: "properties.provisioningState",
        type: {
          name: "Enum",
          allowedValues: ["Creating", "Updating", "Deleting", "Succeeded", "Failed", "Locked"]
        }
      },
      resourceOperationError: {
        readOnly: true,
        serializedName: "properties.resourceOperationError",
        type: {
          name: "Composite",
          className: "ResourceOperationError"
        }
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "Identity"
        }
      }
    })
  }
};
export var LabPlanNetworkProfile = {
  serializedName: "LabPlanNetworkProfile",
  type: {
    name: "Composite",
    className: "LabPlanNetworkProfile",
    modelProperties: {
      subnetId: {
        serializedName: "subnetId",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var SupportInfo = {
  serializedName: "SupportInfo",
  type: {
    name: "Composite",
    className: "SupportInfo",
    modelProperties: {
      url: {
        serializedName: "url",
        type: {
          name: "String"
        }
      },
      email: {
        serializedName: "email",
        type: {
          name: "String"
        }
      },
      phone: {
        serializedName: "phone",
        type: {
          name: "String"
        }
      },
      instructions: {
        serializedName: "instructions",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabPlanUpdate = {
  serializedName: "LabPlanUpdate",
  type: {
    name: "Composite",
    className: "LabPlanUpdate",
    modelProperties: __assign(__assign({}, TrackedResourceUpdate.type.modelProperties), {
      defaultConnectionProfile: {
        serializedName: "properties.defaultConnectionProfile",
        type: {
          name: "Composite",
          className: "ConnectionProfile"
        }
      },
      defaultAutoShutdownProfile: {
        serializedName: "properties.defaultAutoShutdownProfile",
        type: {
          name: "Composite",
          className: "AutoShutdownProfile"
        }
      },
      defaultNetworkProfile: {
        serializedName: "properties.defaultNetworkProfile",
        type: {
          name: "Composite",
          className: "LabPlanNetworkProfile"
        }
      },
      allowedRegions: {
        serializedName: "properties.allowedRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      sharedGalleryId: {
        serializedName: "properties.sharedGalleryId",
        type: {
          name: "String"
        }
      },
      supportInfo: {
        serializedName: "properties.supportInfo",
        type: {
          name: "Composite",
          className: "SupportInfo"
        }
      },
      linkedLmsInstance: {
        serializedName: "properties.linkedLmsInstance",
        type: {
          name: "String"
        }
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "Identity"
        }
      }
    })
  }
};
export var SaveImageBody = {
  serializedName: "SaveImageBody",
  type: {
    name: "Composite",
    className: "SaveImageBody",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      labVirtualMachineId: {
        serializedName: "labVirtualMachineId",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabNetworkProfile = {
  serializedName: "LabNetworkProfile",
  type: {
    name: "Composite",
    className: "LabNetworkProfile",
    modelProperties: {
      subnetId: {
        serializedName: "subnetId",
        type: {
          name: "String"
        }
      },
      loadBalancerId: {
        serializedName: "loadBalancerId",
        type: {
          name: "String"
        }
      },
      publicIpId: {
        serializedName: "publicIpId",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var Lab = {
  serializedName: "Lab",
  type: {
    name: "Composite",
    className: "Lab",
    modelProperties: __assign(__assign({}, TrackedResource.type.modelProperties), {
      systemData: {
        readOnly: true,
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData"
        }
      },
      autoShutdownProfile: {
        serializedName: "properties.autoShutdownProfile",
        type: {
          name: "Composite",
          className: "AutoShutdownProfile"
        }
      },
      connectionProfile: {
        serializedName: "properties.connectionProfile",
        type: {
          name: "Composite",
          className: "ConnectionProfile"
        }
      },
      virtualMachineProfile: {
        serializedName: "properties.virtualMachineProfile",
        type: {
          name: "Composite",
          className: "VirtualMachineProfile"
        }
      },
      securityProfile: {
        serializedName: "properties.securityProfile",
        type: {
          name: "Composite",
          className: "SecurityProfile"
        }
      },
      rosterProfile: {
        serializedName: "properties.rosterProfile",
        type: {
          name: "Composite",
          className: "RosterProfile"
        }
      },
      labPlanId: {
        serializedName: "properties.labPlanId",
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "properties.title",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String"
        }
      },
      provisioningState: {
        readOnly: true,
        serializedName: "properties.provisioningState",
        type: {
          name: "Enum",
          allowedValues: ["Creating", "Updating", "Deleting", "Succeeded", "Failed", "Locked"]
        }
      },
      networkProfile: {
        serializedName: "properties.networkProfile",
        type: {
          name: "Composite",
          className: "LabNetworkProfile"
        }
      },
      state: {
        readOnly: true,
        serializedName: "properties.state",
        type: {
          name: "Enum",
          allowedValues: ["Draft", "Publishing", "Scaling", "Syncing", "Published"]
        }
      },
      resourceOperationError: {
        readOnly: true,
        serializedName: "properties.resourceOperationError",
        type: {
          name: "Composite",
          className: "ResourceOperationError"
        }
      }
    })
  }
};
export var ImageReference = {
  serializedName: "ImageReference",
  type: {
    name: "Composite",
    className: "ImageReference",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      offer: {
        serializedName: "offer",
        type: {
          name: "String"
        }
      },
      publisher: {
        serializedName: "publisher",
        type: {
          name: "String"
        }
      },
      sku: {
        serializedName: "sku",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "version",
        type: {
          name: "String"
        }
      },
      exactVersion: {
        readOnly: true,
        serializedName: "exactVersion",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var Sku = {
  serializedName: "Sku",
  type: {
    name: "Composite",
    className: "Sku",
    modelProperties: {
      name: {
        required: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      tier: {
        serializedName: "tier",
        type: {
          name: "Enum",
          allowedValues: ["Free", "Basic", "Standard", "Premium"]
        }
      },
      size: {
        serializedName: "size",
        type: {
          name: "String"
        }
      },
      family: {
        serializedName: "family",
        type: {
          name: "String"
        }
      },
      capacity: {
        serializedName: "capacity",
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var VirtualMachineAdditionalCapabilities = {
  serializedName: "VirtualMachineAdditionalCapabilities",
  type: {
    name: "Composite",
    className: "VirtualMachineAdditionalCapabilities",
    modelProperties: {
      installGpuDrivers: {
        serializedName: "installGpuDrivers",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      }
    }
  }
};
export var Credentials = {
  serializedName: "Credentials",
  type: {
    name: "Composite",
    className: "Credentials",
    modelProperties: {
      username: {
        required: true,
        serializedName: "username",
        type: {
          name: "String"
        }
      },
      password: {
        serializedName: "password",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var VirtualMachineProfile = {
  serializedName: "VirtualMachineProfile",
  type: {
    name: "Composite",
    className: "VirtualMachineProfile",
    modelProperties: {
      createOption: {
        required: true,
        serializedName: "createOption",
        type: {
          name: "Enum",
          allowedValues: ["Image", "TemplateVM"]
        }
      },
      imageReference: {
        required: true,
        serializedName: "imageReference",
        type: {
          name: "Composite",
          className: "ImageReference"
        }
      },
      osType: {
        readOnly: true,
        serializedName: "osType",
        type: {
          name: "Enum",
          allowedValues: ["Windows", "Linux"]
        }
      },
      sku: {
        required: true,
        serializedName: "sku",
        type: {
          name: "Composite",
          className: "Sku"
        }
      },
      additionalCapabilities: {
        serializedName: "additionalCapabilities",
        type: {
          name: "Composite",
          className: "VirtualMachineAdditionalCapabilities"
        }
      },
      usageQuota: {
        required: true,
        serializedName: "usageQuota",
        type: {
          name: "TimeSpan"
        }
      },
      useSharedPassword: {
        serializedName: "useSharedPassword",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      adminUser: {
        required: true,
        serializedName: "adminUser",
        type: {
          name: "Composite",
          className: "Credentials"
        }
      },
      nonAdminUser: {
        serializedName: "nonAdminUser",
        type: {
          name: "Composite",
          className: "Credentials"
        }
      }
    }
  }
};
export var SecurityProfile = {
  serializedName: "SecurityProfile",
  type: {
    name: "Composite",
    className: "SecurityProfile",
    modelProperties: {
      registrationCode: {
        readOnly: true,
        serializedName: "registrationCode",
        type: {
          name: "String"
        }
      },
      openAccess: {
        serializedName: "openAccess",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      }
    }
  }
};
export var RosterProfile = {
  serializedName: "RosterProfile",
  type: {
    name: "Composite",
    className: "RosterProfile",
    modelProperties: {
      activeDirectoryGroupId: {
        serializedName: "activeDirectoryGroupId",
        type: {
          name: "String"
        }
      },
      ltiContextId: {
        serializedName: "ltiContextId",
        type: {
          name: "String"
        }
      },
      lmsInstance: {
        serializedName: "lmsInstance",
        type: {
          name: "String"
        }
      },
      ltiClientId: {
        serializedName: "ltiClientId",
        type: {
          name: "String"
        }
      },
      ltiRosterEndpoint: {
        serializedName: "ltiRosterEndpoint",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabUpdate = {
  serializedName: "LabUpdate",
  type: {
    name: "Composite",
    className: "LabUpdate",
    modelProperties: __assign(__assign({}, TrackedResourceUpdate.type.modelProperties), {
      autoShutdownProfile: {
        serializedName: "properties.autoShutdownProfile",
        type: {
          name: "Composite",
          className: "AutoShutdownProfile"
        }
      },
      connectionProfile: {
        serializedName: "properties.connectionProfile",
        type: {
          name: "Composite",
          className: "ConnectionProfile"
        }
      },
      virtualMachineProfile: {
        serializedName: "properties.virtualMachineProfile",
        type: {
          name: "Composite",
          className: "VirtualMachineProfile"
        }
      },
      securityProfile: {
        serializedName: "properties.securityProfile",
        type: {
          name: "Composite",
          className: "SecurityProfile"
        }
      },
      rosterProfile: {
        serializedName: "properties.rosterProfile",
        type: {
          name: "Composite",
          className: "RosterProfile"
        }
      },
      labPlanId: {
        serializedName: "properties.labPlanId",
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "properties.title",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String"
        }
      }
    })
  }
};
export var ProxyResource = {
  serializedName: "ProxyResource",
  type: {
    name: "Composite",
    className: "ProxyResource",
    modelProperties: __assign({}, Resource.type.modelProperties)
  }
};
export var User = {
  serializedName: "User",
  type: {
    name: "Composite",
    className: "User",
    modelProperties: __assign(__assign({}, ProxyResource.type.modelProperties), {
      systemData: {
        readOnly: true,
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData"
        }
      },
      additionalUsageQuota: {
        serializedName: "properties.additionalUsageQuota",
        type: {
          name: "TimeSpan"
        }
      },
      provisioningState: {
        readOnly: true,
        serializedName: "properties.provisioningState",
        type: {
          name: "Enum",
          allowedValues: ["Creating", "Updating", "Deleting", "Succeeded", "Failed", "Locked"]
        }
      },
      resourceOperationError: {
        readOnly: true,
        serializedName: "properties.resourceOperationError",
        type: {
          name: "Composite",
          className: "ResourceOperationError"
        }
      },
      displayName: {
        readOnly: true,
        serializedName: "properties.displayName",
        type: {
          name: "String"
        }
      },
      email: {
        required: true,
        serializedName: "properties.email",
        type: {
          name: "String"
        }
      },
      registrationState: {
        readOnly: true,
        serializedName: "properties.registrationState",
        type: {
          name: "Enum",
          allowedValues: ["Registered", "NotRegistered"]
        }
      },
      invitationState: {
        readOnly: true,
        serializedName: "properties.invitationState",
        type: {
          name: "Enum",
          allowedValues: ["NotSent", "Sending", "Sent", "Failed"]
        }
      },
      invitationSent: {
        readOnly: true,
        serializedName: "properties.invitationSent",
        type: {
          name: "DateTime"
        }
      },
      totalUsage: {
        readOnly: true,
        serializedName: "properties.totalUsage",
        type: {
          name: "TimeSpan"
        }
      }
    })
  }
};
export var UserUpdate = {
  serializedName: "UserUpdate",
  type: {
    name: "Composite",
    className: "UserUpdate",
    modelProperties: {
      additionalUsageQuota: {
        serializedName: "properties.additionalUsageQuota",
        type: {
          name: "TimeSpan"
        }
      }
    }
  }
};
export var InviteBody = {
  serializedName: "InviteBody",
  type: {
    name: "Composite",
    className: "InviteBody",
    modelProperties: {
      text: {
        serializedName: "text",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var VirtualMachineConnectionProfile = {
  serializedName: "VirtualMachineConnectionProfile",
  type: {
    name: "Composite",
    className: "VirtualMachineConnectionProfile",
    modelProperties: {
      privateIpAddress: {
        readOnly: true,
        serializedName: "privateIpAddress",
        type: {
          name: "String"
        }
      },
      sshAuthority: {
        readOnly: true,
        serializedName: "sshAuthority",
        type: {
          name: "String"
        }
      },
      sshInBrowserUrl: {
        readOnly: true,
        serializedName: "sshInBrowserUrl",
        type: {
          name: "String"
        }
      },
      rdpAuthority: {
        readOnly: true,
        serializedName: "rdpAuthority",
        type: {
          name: "String"
        }
      },
      rdpInBrowserUrl: {
        readOnly: true,
        serializedName: "rdpInBrowserUrl",
        type: {
          name: "String"
        }
      },
      adminUsername: {
        readOnly: true,
        serializedName: "adminUsername",
        type: {
          name: "String"
        }
      },
      nonAdminUsername: {
        readOnly: true,
        serializedName: "nonAdminUsername",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var VirtualMachine = {
  serializedName: "VirtualMachine",
  type: {
    name: "Composite",
    className: "VirtualMachine",
    modelProperties: __assign(__assign({}, ProxyResource.type.modelProperties), {
      systemData: {
        readOnly: true,
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData"
        }
      },
      provisioningState: {
        readOnly: true,
        serializedName: "properties.provisioningState",
        type: {
          name: "Enum",
          allowedValues: ["Creating", "Updating", "Deleting", "Succeeded", "Failed", "Locked"]
        }
      },
      state: {
        readOnly: true,
        serializedName: "properties.state",
        type: {
          name: "Enum",
          allowedValues: ["Stopped", "Starting", "Running", "Stopping", "ResettingPassword", "Reimaging", "Redeploying"]
        }
      },
      resourceOperationError: {
        readOnly: true,
        serializedName: "properties.resourceOperationError",
        type: {
          name: "Composite",
          className: "ResourceOperationError"
        }
      },
      connectionProfile: {
        readOnly: true,
        serializedName: "properties.connectionProfile",
        type: {
          name: "Composite",
          className: "VirtualMachineConnectionProfile"
        }
      },
      claimedByUserId: {
        readOnly: true,
        serializedName: "properties.claimedByUserId",
        type: {
          name: "String"
        }
      },
      vmType: {
        readOnly: true,
        serializedName: "properties.vmType",
        type: {
          name: "Enum",
          allowedValues: ["User", "Template"]
        }
      }
    })
  }
};
export var ResetPasswordBody = {
  serializedName: "ResetPasswordBody",
  type: {
    name: "Composite",
    className: "ResetPasswordBody",
    modelProperties: {
      username: {
        required: true,
        serializedName: "username",
        type: {
          name: "String"
        }
      },
      password: {
        required: true,
        serializedName: "password",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var Schedule = {
  serializedName: "Schedule",
  type: {
    name: "Composite",
    className: "Schedule",
    modelProperties: __assign(__assign({}, ProxyResource.type.modelProperties), {
      systemData: {
        readOnly: true,
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData"
        }
      },
      startAt: {
        serializedName: "properties.startAt",
        type: {
          name: "DateTime"
        }
      },
      stopAt: {
        serializedName: "properties.stopAt",
        type: {
          name: "DateTime"
        }
      },
      recurrencePattern: {
        serializedName: "properties.recurrencePattern",
        type: {
          name: "Composite",
          className: "RecurrencePattern"
        }
      },
      timeZoneId: {
        serializedName: "properties.timeZoneId",
        type: {
          name: "String"
        }
      },
      notes: {
        serializedName: "properties.notes",
        type: {
          name: "String"
        }
      },
      provisioningState: {
        readOnly: true,
        serializedName: "properties.provisioningState",
        type: {
          name: "Enum",
          allowedValues: ["Creating", "Updating", "Deleting", "Succeeded", "Failed", "Locked"]
        }
      },
      resourceOperationError: {
        readOnly: true,
        serializedName: "properties.resourceOperationError",
        type: {
          name: "Composite",
          className: "ResourceOperationError"
        }
      }
    })
  }
};
export var RecurrencePattern = {
  serializedName: "RecurrencePattern",
  type: {
    name: "Composite",
    className: "RecurrencePattern",
    modelProperties: {
      frequency: {
        required: true,
        serializedName: "frequency",
        type: {
          name: "Enum",
          allowedValues: ["Daily", "Weekly"]
        }
      },
      weekDays: {
        serializedName: "weekDays",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
            }
          }
        }
      },
      interval: {
        serializedName: "interval",
        constraints: {
          InclusiveMaximum: 365,
          InclusiveMinimum: 1
        },
        type: {
          name: "Number"
        }
      },
      expirationDate: {
        required: true,
        serializedName: "expirationDate",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
export var ScheduleUpdate = {
  serializedName: "ScheduleUpdate",
  type: {
    name: "Composite",
    className: "ScheduleUpdate",
    modelProperties: {
      startAt: {
        serializedName: "properties.startAt",
        type: {
          name: "DateTime"
        }
      },
      stopAt: {
        serializedName: "properties.stopAt",
        type: {
          name: "DateTime"
        }
      },
      recurrencePattern: {
        serializedName: "properties.recurrencePattern",
        type: {
          name: "Composite",
          className: "RecurrencePattern"
        }
      },
      timeZoneId: {
        serializedName: "properties.timeZoneId",
        type: {
          name: "String"
        }
      },
      notes: {
        serializedName: "properties.notes",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var Image = {
  serializedName: "Image",
  type: {
    name: "Composite",
    className: "Image",
    modelProperties: __assign(__assign({}, ProxyResource.type.modelProperties), {
      systemData: {
        readOnly: true,
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData"
        }
      },
      enabledState: {
        serializedName: "properties.enabledState",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      provisioningState: {
        readOnly: true,
        serializedName: "properties.provisioningState",
        type: {
          name: "Enum",
          allowedValues: ["Creating", "Updating", "Deleting", "Succeeded", "Failed", "Locked"]
        }
      },
      displayName: {
        readOnly: true,
        serializedName: "properties.displayName",
        type: {
          name: "String"
        }
      },
      description: {
        readOnly: true,
        serializedName: "properties.description",
        type: {
          name: "String"
        }
      },
      iconUrl: {
        readOnly: true,
        serializedName: "properties.iconUrl",
        type: {
          name: "String"
        }
      },
      author: {
        readOnly: true,
        serializedName: "properties.author",
        type: {
          name: "String"
        }
      },
      osType: {
        readOnly: true,
        serializedName: "properties.osType",
        type: {
          name: "Enum",
          allowedValues: ["Windows", "Linux"]
        }
      },
      plan: {
        readOnly: true,
        serializedName: "properties.plan",
        type: {
          name: "String"
        }
      },
      termsStatus: {
        readOnly: true,
        serializedName: "properties.termsStatus",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      offer: {
        readOnly: true,
        serializedName: "properties.offer",
        type: {
          name: "String"
        }
      },
      publisher: {
        readOnly: true,
        serializedName: "properties.publisher",
        type: {
          name: "String"
        }
      },
      sku: {
        readOnly: true,
        serializedName: "properties.sku",
        type: {
          name: "String"
        }
      },
      version: {
        readOnly: true,
        serializedName: "properties.version",
        type: {
          name: "String"
        }
      },
      sharedGalleryId: {
        readOnly: true,
        serializedName: "properties.sharedGalleryId",
        type: {
          name: "String"
        }
      },
      availableRegions: {
        serializedName: "properties.availableRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      osState: {
        readOnly: true,
        serializedName: "properties.osState",
        type: {
          name: "Enum",
          allowedValues: ["Generalized", "Specialized"]
        }
      }
    })
  }
};
export var ImageUpdate = {
  serializedName: "ImageUpdate",
  type: {
    name: "Composite",
    className: "ImageUpdate",
    modelProperties: {
      enabledState: {
        serializedName: "properties.enabledState",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      }
    }
  }
};
export var ErrorAdditionalInfo = {
  serializedName: "ErrorAdditionalInfo",
  type: {
    name: "Composite",
    className: "ErrorAdditionalInfo",
    modelProperties: {
      type: {
        readOnly: true,
        serializedName: "type",
        type: {
          name: "String"
        }
      },
      info: {
        readOnly: true,
        serializedName: "info",
        type: {
          name: "Object"
        }
      }
    }
  }
};
export var ErrorDetail = {
  serializedName: "ErrorDetail",
  type: {
    name: "Composite",
    className: "ErrorDetail",
    modelProperties: {
      code: {
        readOnly: true,
        serializedName: "code",
        type: {
          name: "String"
        }
      },
      message: {
        readOnly: true,
        serializedName: "message",
        type: {
          name: "String"
        }
      },
      target: {
        readOnly: true,
        serializedName: "target",
        type: {
          name: "String"
        }
      },
      details: {
        readOnly: true,
        serializedName: "details",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ErrorDetail"
            }
          }
        }
      },
      additionalInfo: {
        readOnly: true,
        serializedName: "additionalInfo",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ErrorAdditionalInfo"
            }
          }
        }
      }
    }
  }
};
export var OperationResult = {
  serializedName: "OperationResult",
  type: {
    name: "Composite",
    className: "OperationResult",
    modelProperties: {
      id: {
        readOnly: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      name: {
        readOnly: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      status: {
        required: true,
        serializedName: "status",
        type: {
          name: "Enum",
          allowedValues: ["NotStarted", "InProgress", "Succeeded", "Failed", "Canceled"]
        }
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime"
        }
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime"
        }
      },
      percentComplete: {
        serializedName: "percentComplete",
        type: {
          name: "Number"
        }
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "ErrorDetail"
        }
      }
    }
  }
};
export var UsageName = {
  serializedName: "UsageName",
  type: {
    name: "Composite",
    className: "UsageName",
    modelProperties: {
      localizedValue: {
        serializedName: "localizedValue",
        type: {
          name: "String"
        }
      },
      skuInstances: {
        serializedName: "skuInstances",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      value: {
        serializedName: "value",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var Usage = {
  serializedName: "Usage",
  type: {
    name: "Composite",
    className: "Usage",
    modelProperties: {
      currentValue: {
        serializedName: "currentValue",
        type: {
          name: "Number"
        }
      },
      limit: {
        serializedName: "limit",
        type: {
          name: "Number"
        }
      },
      unit: {
        serializedName: "unit",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "Composite",
          className: "UsageName"
        }
      },
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabServicesSkuCapacity = {
  serializedName: "LabServicesSkuCapacity",
  type: {
    name: "Composite",
    className: "LabServicesSkuCapacity",
    modelProperties: {
      default: {
        readOnly: true,
        serializedName: "default",
        type: {
          name: "Number"
        }
      },
      minimum: {
        readOnly: true,
        serializedName: "minimum",
        type: {
          name: "Number"
        }
      },
      maximum: {
        readOnly: true,
        serializedName: "maximum",
        type: {
          name: "Number"
        }
      },
      scaleType: {
        readOnly: true,
        serializedName: "scaleType",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabServicesSkuCapabilities = {
  serializedName: "LabServicesSkuCapabilities",
  type: {
    name: "Composite",
    className: "LabServicesSkuCapabilities",
    modelProperties: {
      name: {
        readOnly: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      value: {
        readOnly: true,
        serializedName: "value",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabServicesSkuCost = {
  serializedName: "LabServicesSkuCost",
  type: {
    name: "Composite",
    className: "LabServicesSkuCost",
    modelProperties: {
      meterId: {
        readOnly: true,
        serializedName: "meterId",
        type: {
          name: "String"
        }
      },
      quantity: {
        readOnly: true,
        serializedName: "quantity",
        type: {
          name: "Number"
        }
      },
      extendedUnit: {
        readOnly: true,
        serializedName: "extendedUnit",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabServicesSkuRestrictions = {
  serializedName: "LabServicesSkuRestrictions",
  type: {
    name: "Composite",
    className: "LabServicesSkuRestrictions",
    modelProperties: {
      type: {
        readOnly: true,
        serializedName: "type",
        type: {
          name: "String"
        }
      },
      values: {
        readOnly: true,
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      reasonCode: {
        readOnly: true,
        serializedName: "reasonCode",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabServicesSku = {
  serializedName: "LabServicesSku",
  type: {
    name: "Composite",
    className: "LabServicesSku",
    modelProperties: {
      resourceType: {
        readOnly: true,
        serializedName: "resourceType",
        type: {
          name: "String"
        }
      },
      name: {
        readOnly: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      tier: {
        readOnly: true,
        serializedName: "tier",
        type: {
          name: "String"
        }
      },
      size: {
        readOnly: true,
        serializedName: "size",
        type: {
          name: "String"
        }
      },
      family: {
        readOnly: true,
        serializedName: "family",
        type: {
          name: "String"
        }
      },
      capacity: {
        serializedName: "capacity",
        type: {
          name: "Composite",
          className: "LabServicesSkuCapacity"
        }
      },
      capabilities: {
        readOnly: true,
        serializedName: "capabilities",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "LabServicesSkuCapabilities"
            }
          }
        }
      },
      locations: {
        readOnly: true,
        serializedName: "locations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      costs: {
        readOnly: true,
        serializedName: "costs",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "LabServicesSkuCost"
            }
          }
        }
      },
      restrictions: {
        readOnly: true,
        serializedName: "restrictions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "LabServicesSkuRestrictions"
            }
          }
        }
      }
    }
  }
};
export var OperationDisplay = {
  serializedName: "Operation-display",
  type: {
    name: "Composite",
    className: "OperationDisplay",
    modelProperties: {
      provider: {
        readOnly: true,
        serializedName: "provider",
        type: {
          name: "String"
        }
      },
      resource: {
        readOnly: true,
        serializedName: "resource",
        type: {
          name: "String"
        }
      },
      operation: {
        readOnly: true,
        serializedName: "operation",
        type: {
          name: "String"
        }
      },
      description: {
        readOnly: true,
        serializedName: "description",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var Operation = {
  serializedName: "Operation",
  type: {
    name: "Composite",
    className: "Operation",
    modelProperties: {
      name: {
        readOnly: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      isDataAction: {
        readOnly: true,
        serializedName: "isDataAction",
        type: {
          name: "Boolean"
        }
      },
      display: {
        serializedName: "display",
        type: {
          name: "Composite",
          className: "OperationDisplay"
        }
      },
      origin: {
        readOnly: true,
        serializedName: "origin",
        type: {
          name: "String"
        }
      },
      actionType: {
        readOnly: true,
        serializedName: "actionType",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var OperationListResult = {
  serializedName: "OperationListResult",
  type: {
    name: "Composite",
    className: "OperationListResult",
    modelProperties: {
      value: {
        readOnly: true,
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Operation"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var PagedLabPlans = {
  serializedName: "PagedLabPlans",
  type: {
    name: "Composite",
    className: "PagedLabPlans",
    modelProperties: {
      value: {
        readOnly: true,
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "LabPlan"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var PagedLabs = {
  serializedName: "PagedLabs",
  type: {
    name: "Composite",
    className: "PagedLabs",
    modelProperties: {
      value: {
        readOnly: true,
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Lab"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var PagedUsers = {
  serializedName: "PagedUsers",
  type: {
    name: "Composite",
    className: "PagedUsers",
    modelProperties: {
      value: {
        readOnly: true,
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "User"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var PagedVirtualMachines = {
  serializedName: "PagedVirtualMachines",
  type: {
    name: "Composite",
    className: "PagedVirtualMachines",
    modelProperties: {
      value: {
        readOnly: true,
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "VirtualMachine"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var PagedSchedules = {
  serializedName: "PagedSchedules",
  type: {
    name: "Composite",
    className: "PagedSchedules",
    modelProperties: {
      value: {
        readOnly: true,
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Schedule"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var PagedImages = {
  serializedName: "PagedImages",
  type: {
    name: "Composite",
    className: "PagedImages",
    modelProperties: {
      value: {
        readOnly: true,
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Image"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var ListUsagesResult = {
  serializedName: "ListUsagesResult",
  type: {
    name: "Composite",
    className: "ListUsagesResult",
    modelProperties: {
      value: {
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Usage"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var PagedLabServicesSkus = {
  serializedName: "PagedLabServicesSkus",
  type: {
    name: "Composite",
    className: "PagedLabServicesSkus",
    modelProperties: {
      value: {
        readOnly: true,
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "LabServicesSku"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};